// import { useEffect, useMemo, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { motion } from "framer-motion";
// import { User, UserX, X, AlertTriangle } from 'lucide-react';
// import { toast } from 'react-toastify';
// import styles from './ProfilePage.module.css';
// import { Header } from "../components/Header";
// import { Footer } from "../components/Footer";
// import { deactivateApi, loginApi } from '../http/api';
// import axios from 'axios';
// import Loader from '../components/Loader';
// import { useTranslate } from '../components/UseTranslate';

// export function ProfilePage() {
//   const navigate = useNavigate();

//   const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
//   const [deactivating, setDeactivating] = useState(false);
//   const [showDeactivateModal, setShowDeactivateModal] = useState(false);

//   const User_ = localStorage.getItem('user');
//   const { t } = useTranslate()

//   const LoginUser = async () => {
//     const alias = localStorage.getItem('alias');
//     const name = 'Food Box User';

    

//     try {
//       const result = await axios.post(loginApi, { name: name, alias: alias });
//       console.log(result);
//       if (result?.data?.user[0]) {
//         localStorage.setItem('user', JSON.stringify(result?.data?.user[0]));
//         setUser(result?.data?.user[0]);
//       } else {
//         navigate('/');
//       }
//     } catch (err) {
//       console.log(err, 'errr========');
//     }
//   };

//   useEffect(() => {
//     if (!User_) {
//       LoginUser();
//     }
//   }, []);

//   const handleDeactivate = async () => {
//     const alias = localStorage.getItem('alias');

//     setDeactivating(true);
//     try {
//       const resp = await axios.post(deactivateApi, { alias: alias });

//       if (resp.data.status == 1) {
//         toast.success(t(resp.data.result));
//         setShowDeactivateModal(false);
//         localStorage.clear();
//         navigate('/subscribe');
//       } else {
//         toast.error(`${t('Some Error Occured While Deactivation!!')}`);
//       }
//     } catch (err) {
//       console.log(err);
//         toast.error(`${t('Some Error Occured While Deactivation!!')}`);
//     } finally {
//       setDeactivating(false);
//     }
//   };

//   if (!user) {
//     return (
//       <>
//         <Loader />
//       </>
//     );
//   }

//   return (
//     <div className={styles.container}>
//       <Header />

//       <section className={styles.contentSection}>
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className={styles.profileCard}
//         >
//           {/* Avatar */}
//           <motion.div
//             initial={{ scale: 0 }}
//             animate={{ scale: 1 }}
//             transition={{ type: 'spring', stiffness: 200, delay: 0.15 }}
//             className={styles.avatarWrapper}
//           >
//             <div className={styles.avatarCircle}>
//               <User className={styles.avatarIcon} />
//             </div>
//           </motion.div>

//           {/* Name */}
//           <div className={styles.nameBlock}>
//             <p className={styles.nameLabel}>
//               <span className={styles.chevron}>&gt;</span>
//               {t('Your Name')}
//               <span className={styles.chevron}>&lt;</span>
//             </p>
//             <h1 className={styles.userName}>{user?.name}</h1>
//           </div>

//           {/* Divider */}
//           <div className={styles.divider} />

//           {/* Deactivate Button */}
//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             type="button"
//             className={styles.deactivateButton}
//             onClick={() => setShowDeactivateModal(true)}
//           >
//             <UserX className={styles.iconMedium} />
//             {t('Deactivate Account')}
//           </motion.button>
//         </motion.div>
//       </section>

//       <Footer />

//       {/* Deactivate Confirmation Modal */}
//       {showDeactivateModal && (
//         <div
//           className={styles.modalOverlay}
//           onClick={() => !deactivating && setShowDeactivateModal(false)}
//         >
//           <motion.div
//             initial={{ opacity: 0, scale: 0.95 }}
//             animate={{ opacity: 1, scale: 1 }}
//             className={styles.modalCard}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className={styles.modalCloseRow}>
//               <button
//                 type="button"
//                 className={styles.modalCloseButton}
//                 onClick={() => !deactivating && setShowDeactivateModal(false)}
//                 disabled={deactivating}
//                 aria-label="Close"
//               >
//                 <X className={styles.iconSmall} />
//               </button>
//             </div>

//             <div className={styles.modalIconWrapper}>
//               <div className={styles.modalIconCircle}>
//                 <AlertTriangle className={styles.modalIcon} />
//               </div>
//             </div>

//             <div className={styles.modalTextBlock}>
//               <h3 className={styles.modalTitle}>{t('Deactivate Account')}?</h3>
//               <p className={styles.modalDescription}>
//                 {t("This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone")}
//               </p>
//             </div>

//             <div className={styles.modalActions}>
//               <button
//                 type="button"
//                 className={styles.modalConfirmButton}
//                 onClick={handleDeactivate}
//                 disabled={deactivating}
//               >
//                 {deactivating ? t('Deactivating...') : t('Yes, Deactivate')}
//               </button>
//               <button
//                 type="button"
//                 className={styles.modalCancelButton}
//                 onClick={() => setShowDeactivateModal(false)}
//                 disabled={deactivating}
//               >
//                 {t('Cancel')}
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       )}
//     </div>
//   );
// }
























import { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { User, UserX, X, AlertTriangle } from 'lucide-react';
import { toast } from 'react-toastify';
import styles from './ProfilePage.module.css';
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { deactivateApi, loginApi } from '../http/api';
import axios from 'axios';
import Loader from '../components/Loader';
import { useTranslate } from '../components/UseTranslate';

// Safely read + parse the 'user' key from localStorage.
// Never throws — returns null and clears the key if the value is corrupted.


const defaultUser = {
  name: "Food Box User",
  alias: "",
  profile_url: ""
};

function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.warn('Corrupted "user" value in localStorage, clearing it:', e);
    localStorage.removeItem('user');
    return null;
  }
}

export function ProfilePage() {
  const navigate = useNavigate();

  // Lazy initializer — runs once on mount, not on every render
  const [user, setUser] = useState(() => getStoredUser() || defaultUser);

  const [deactivating, setDeactivating] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const { t } = useTranslate();

  const LoginUser = async () => {
    const alias = localStorage.getItem('alias');
    const name = 'Food Box User';

    try {
      const result = await axios.post(loginApi, { name: name, alias: alias });
      console.log(result);
      if (result?.data?.user?.[0]) {
        localStorage.setItem('user', JSON.stringify(result.data.user[0]));
        setUser(result.data.user[0]);
      } else {
        navigate('/');
      }
    } catch (err) {
      console.log(err, 'errr========');
    }
  };

  useEffect(() => {
    // Re-check localStorage directly (not the stale `user` state) each time this runs
    const storedUser = getStoredUser();
    if (!storedUser) {
      LoginUser();
    }
  }, []);

  const handleDeactivate = async () => {
    const alias = localStorage.getItem('alias');

    setDeactivating(true);
    try {
      const resp = await axios.post(deactivateApi, { alias: alias });

      if (resp.data.status == 1) {
        toast.success(t(resp.data.result));
        setShowDeactivateModal(false);
        localStorage.clear();
        navigate('/subscribe');
      } else {
        toast.error(`${t('Some Error Occured While Deactivation!!')}`);
      }
    } catch (err) {
      console.log(err);
      toast.error(`${t('Some Error Occured While Deactivation!!')}`);
    } finally {
      setDeactivating(false);
    }
  };

  if (!user) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <div className={styles.container}>
      <Header />

      <section className={styles.contentSection}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className={styles.profileCard}
        >
          {/* Avatar */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: 'spring', stiffness: 200, delay: 0.15 }}
            className={styles.avatarWrapper}
          >
            <div className={styles.avatarCircle}>
              <User className={styles.avatarIcon} />
            </div>
          </motion.div>

          {/* Name */}
          <div className={styles.nameBlock}>
            <p className={styles.nameLabel}>
              <span className={styles.chevron}>&gt;</span>
              {t('Your Name')}
              <span className={styles.chevron}>&lt;</span>
            </p>
            <h1 className={styles.userName}>{user?.name}</h1>
          </div>

          {/* Divider */}
          <div className={styles.divider} />

          {/* Deactivate Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="button"
            className={styles.deactivateButton}
            onClick={() => setShowDeactivateModal(true)}
          >
            <UserX className={styles.iconMedium} />
            {t('Deactivate Account')}
          </motion.button>
        </motion.div>
      </section>

      <Footer />

      {/* Deactivate Confirmation Modal */}
      {showDeactivateModal && (
        <div
          className={styles.modalOverlay}
          onClick={() => !deactivating && setShowDeactivateModal(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className={styles.modalCard}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalCloseRow}>
              <button
                type="button"
                className={styles.modalCloseButton}
                onClick={() => !deactivating && setShowDeactivateModal(false)}
                disabled={deactivating}
                aria-label="Close"
              >
                <X className={styles.iconSmall} />
              </button>
            </div>

            <div className={styles.modalIconWrapper}>
              <div className={styles.modalIconCircle}>
                <AlertTriangle className={styles.modalIcon} />
              </div>
            </div>

            <div className={styles.modalTextBlock}>
              <h3 className={styles.modalTitle}>{t('Deactivate Account')}?</h3>
              <p className={styles.modalDescription}>
                {t("This will deactivate your account and you'll lose access until you resubscribe. This action cannot be undone")}
              </p>
            </div>

            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.modalConfirmButton}
                onClick={handleDeactivate}
                disabled={deactivating}
              >
                {deactivating ? t('Deactivating...') : t('Yes, Deactivate')}
              </button>
              <button
                type="button"
                className={styles.modalCancelButton}
                onClick={() => setShowDeactivateModal(false)}
                disabled={deactivating}
              >
                {t('Cancel')}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}